<template>

	<div id="home">

		<div class="hero-stage">

			<HomeHero />

			<div class="scroll"><span></span></div>

		</div>

		<HomeAbout />

		<HomePillars />

		<HomeSolve />

		<HomeSectionWhy />

		<!-- <HomeInformation /> -->
		
		<!-- <HomeInsights /> -->
		
		<!--  -->
		
		<!-- <HomeProjects /> -->

	</div>

</template>


<script>
/* eslint-disable */
import HomeHero from './Home/Hero.vue';
import HomeAbout from './Home/About.vue';
import HomePillars from './Home/Pillars.vue';
import HomeSolve from './Home/Solve.vue';
import HomeSectionWhy from './Home/SectionWhy.vue';
import HomeInformation from './Home/Information.vue';
import HomeInsights from './Home/Insights.vue';
import HomeProjects from './Home/Projects.vue';

export default {
	name: 'Home',
	components: {
		HomeHero,
		HomeAbout,
		HomePillars,
		HomeSolve,
		HomeSectionWhy,
		HomeInformation,
		HomeInsights,
		HomeProjects
	},
	mounted() {
		document.title = 'Bridgerocks | ' + this.$options.filters.toTitleCase(this.$options.filters.i('home'));
		if(window.mainUI && typeof window.mainUI === 'function')
			setTimeout(window.mainUI, 150);
	}
};
</script>